import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { ProgramsState } from '../programs/Types';
import { IdleState } from '../idle/Types';
import { Member, PaymentInfo, MembersState, MembersResponseData } from '../members/members.types';
import { BusinessState } from 'src/business/business.types';
import CommonFeatures from '../commons/CommonFeatures';
import TextField from 'material-ui/TextField';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import { dateFromString } from '../util/date-util';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import FlatButton from 'material-ui/FlatButton';
// import MaterialTable, { MTableToolbar } from 'material-table';

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly membersState: MembersState
  readonly programsState: ProgramsState
  readonly businessState: BusinessState
};
type States = {

};

class LeadsComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2 mb-3">
          <div className="col-auto">
            <h3>Leads</h3>
          </div>
        </div>
        <div className="row mb-2 align-items-center">
          <div className="col-auto">
            <TextField
              hintText="Search"
              floatingLabelText="Search"
            />
          </div>
        </div>
        <div className="row mb-4 mt-4 animated fadeIn">
          <div
            className="col-12"
            style={overlayStyle(true)}
          >
            {renderOverlayLoading(true, '25%')}

          </div>
        </div>
      </CommonFeatures>
    );
  }

  private renderUpdateButton = (cellInfo) => {
    return (
      <FlatButton
        icon={<CheckCircle />}
      />
    );
  }
}

export default LeadsComponent;


// WEBPACK FOOTER //
// ./src/leads/LeadsComponent.tsx